"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";

type Props = {
  eyebrow: string;
  titulo: string;
  descripcion: string;
  imagen: string;
  link: string;
  buttonLabel: string;
  index: number;
};

const YELLOW = "#ffb800";
const NAVY = "#102542";

export default function TransporteCard({
  eyebrow,
  titulo,
  descripcion,
  imagen,
  link,
  buttonLabel,
  index,
}: Props) {
  return (
    <Link
      href={link}
      className="group relative bg-white flex flex-col transition-colors hover:bg-gray-50 overflow-hidden"
    >
      {/* Accent strip top — appears on hover */}
      <span
        className="absolute top-0 left-0 right-0 h-0.5 origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 z-10"
        style={{ backgroundColor: YELLOW }}
      />

      {/* Imagen */}
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-gray-100">
        <Image
          src={imagen}
          alt={titulo}
          fill
          sizes="(max-width: 768px) 100vw, 33vw"
          className="object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Contenido */}
      <div className="p-8 flex flex-col flex-1">
        <div className="flex items-start justify-between mb-5">
          <div className="flex items-center gap-2">
            <span
              className="text-[11px] font-mono uppercase tracking-wider text-gray-400 tabular-nums"
            >
              {String(index).padStart(2, "0")}
            </span>
            <span className="text-gray-300">·</span>
            <span className="text-[11px] font-mono uppercase tracking-wider text-gray-500">
              {eyebrow}
            </span>
          </div>
          <ArrowUpRight
            className="w-4 h-4 text-gray-400 transition-all duration-300 group-hover:text-[#102542] group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
          />
        </div>

        <h3
          className="text-xl font-bold tracking-tight mb-3"
          style={{ color: NAVY }}
        >
          {titulo}
        </h3>
        <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-1">
          {descripcion}
        </p>

        <span
          className="inline-flex items-center gap-1.5 text-xs uppercase tracking-wider font-semibold transition-all group-hover:gap-2.5"
          style={{ color: NAVY }}
        >
          {buttonLabel}
          <span
            className="w-6 h-px transition-all duration-300 group-hover:w-10"
            style={{ backgroundColor: YELLOW }}
          />
        </span>
      </div>
    </Link>
  );
}
